// ---------------------------------------------------------------------------
// Claim Desk contact details — EDIT THESE IN ONE PLACE.
// Update the phone numbers / email below and every button, link, tel:, wa.me
// and the downloadable contact card across the site updates automatically.
// ---------------------------------------------------------------------------

export const CLAIM_DESK = {
  primary: { name: "Prashant K. Unadkat", phone: "+91 95100 20907" },
  backups: [
    { name: "Backup Line 1", phone: "+91 92271 36363" },
    { name: "Backup Line 2", phone: "+91 79840 92849" },
  ],
  email: "insure@kavachbox.com",
  // WhatsApp number for the Claim Desk (usually the primary line).
  whatsapp: "+91 95100 20907",
  hours: "24×7 · every day",
};

// Default WhatsApp message pre-filled when a user taps a Claim Desk WhatsApp button.
export const CLAIM_DESK_WA_MESSAGE =
  "Hi Kavach Box Claim Desk, I need help with an insurance claim.";

// tel: href — strips spaces/dashes, keeps leading +.
export const telHref = (phone) => `tel:${(phone || "").replace(/[^\d+]/g, "")}`;

// wa.me href — digits only, optional pre-filled message.
export const waHref = (phone, message) => {
  const digits = (phone || "").replace(/\D/g, "");
  return `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};

// mailto: href with optional subject.
export const mailHref = (email, subject) =>
  `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;

// Build a downloadable .vcf (vCard) with all Claim Desk numbers + email.
export const buildClaimDeskVCard = () => {
  const clean = (p) => (p || "").replace(/[^\d+]/g, "");
  const tels = [
    `TEL;TYPE=CELL;TYPE=VOICE:${clean(CLAIM_DESK.primary.phone)}`,
    ...CLAIM_DESK.backups.map((b) => `TEL;TYPE=CELL;TYPE=VOICE:${clean(b.phone)}`),
  ];
  return [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "FN:Kavach Box Claim Desk",
    "N:Claim Desk;Kavach Box;;;",
    "ORG:Kavach Box — Shree Finserv Group",
    "TITLE:24/7 Claim Desk",
    ...tels,
    `EMAIL;TYPE=INTERNET:${CLAIM_DESK.email}`,
    "NOTE:24x7 Claim Desk — claim assistance, backup contacts and dispute escalation support.",
    "END:VCARD",
  ].join("\r\n");
};
